import { BaseIndicatorResult } from 'src/app/indicator/models/base-indicator-result';

export class FileResult extends BaseIndicatorResult {
    private data: any;
    private filename: string;

    constructor(ok: boolean, status: number, statusText: string, data: any, filename: string) {
        super(ok, status, statusText);
        this.data = data;
        this.filename = filename;
    }

    get Data(): any {
        return this.data;
    }

    get FileName(): string {
        return this.filename;
    }
}
